<!--  -->
<template>
  <div class="couppon_card_box">
    <div class="title">专属优惠券</div>
    <ul>
      <li v-for="(item, index) in couponList" :key="index" @click="onClick(item, index)">
        <CouponsCard :couponInfo="item" class="couppon_card">
          <div class="slot" v-if="isUnlock">
            <div class="btn" v-if="!item.alreadyGet">
              领取
            </div>
            <div class="btn active" v-else>查看</div>
          </div>
        </CouponsCard>
      </li>
    </ul>
  </div>
</template>

<script>
import { reqReceiveCoupon } from '@/api/coupon/index';
import { reqCouponList } from '@/api/newUser/index';
import wx from 'weixin-js-sdk';
import CouponsCard from './CouponsCard.vue';
import { GetDateStr } from '@/utils/tools'


export default {
  props: {
    couponIds: {
      type: Array,
      value: [],
    },
    activeTab: {
      type: Number,
      value: 20,
    },
    userMemberInfo: {
      type: Object,
      default: () => ({
        level: 0, // 0 普通用户 10 试用会员 20 普通会员 30 高级会员
        levelName: '普通用户',
        deadlineStartTime: '',
        deadlineEndTime: '', // 会员到期时间
        isTryoutMember: null, // 是否领取过试用会员
        beforeMemberLevel: null, // 上一次会员等级
      }),
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    CouponsCard,
  },
  data() {
    return {
      couponList: [],
    };
  },
  computed: {
    isUnlock() {
      const { level } = this.userMemberInfo;
      const { id } = this.userInfo;
      const flag = id && ((level === 30 && this.activeTab === 30) || ([10, 20, 40, 50, 60].includes(level) && this.activeTab === 20));
      return !!flag;
    },
  },
  watch: {
    couponIds: {
      handler(val) {
        if (val.length) {
          this.getCoupon();
        }
      },
      immediate: true,
    },
  },
  methods: {
    onClick(item, index) {
      if (!this.isUnlock) return;
      if (!item.alreadyGet) {
        this.receiveCoupon(item, index);
      } else {
        this.toUse();
      }
    },
    async getCoupon() {
      console.log('this.couponIds11111', this.couponIds);
      if (!this.couponIds[0]) return;
      const ids = `couponId=${this.couponIds?.map((item) => item).join('&couponId=')}`;
      const { data } = await reqCouponList(ids);
      this.couponList = data || [];
      this.couponList.forEach((element) => {
        let dateTimeInfo = null;
        if (element.effectiveTimeType === 1) {
          dateTimeInfo = `领取后${element.effectiveDays}天内有效`;
        } else {
          dateTimeInfo = `${element.effectiveTimeBegin
            .slice(0, 11)
            .replace(/-/g, '.')}-${element.effectiveTimeEnd.slice(0, 11).replace(/-/g, '.')}`;
        }
        Object.assign(element, { dateTimeInfo, couponName: element.frontEndName });
      });
    },
    async receiveCoupon(item, index) {
      if (!this.userInfo.id) {
        return;
      }
      const res = await reqReceiveCoupon({
        couponId: String(item.couponId),
        couponVersion: Number(item.couponVersion),
        isLink: 0,
        fitPlatform: 1,
        fitEndPoint: this.$root.$data.isApp ? 2 : 4,
        terminalMark: this.$global.terminalMark
      });
      if (res.code === 0) {
        this.$toast('领取成功');
        Object.assign(item, { alreadyGet: 1 });
        this.$set(this.couponList, index, item);
        this.openNotice(item);
      } else {
        this.$toast(res.msg);
      }
    },
    openNotice(item) {
      const { couponId, couponName, effectiveTimeType, effectiveTimeEnd, effectiveDays } = item;
      const expireTime =
        effectiveTimeType === 1 ? GetDateStr(effectiveDays) : effectiveTimeEnd;
      if (this.$root.$data.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/openNotice/index?type=1&businessId=${couponId}&businessName=${couponName}&expireTime=${expireTime}`,
        });
      }
    },
    toUse() {
      const { origin } = window.location;
      let path = `${origin}/ark/personalCenter/myCoupon?`;
      if (this.$root.$data.isApp) {
        this.$sendToApp('openNewWebView', { url: path }, false);
      } else if (this.$root.miniprogram) {
        const url = window.location.href;
        const [, searchParams] = url.split('?');
        const params = searchParams.split('&');
        if (params) {
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (ExcludequeryArr.includes(key) && value) query += `${key}=${value}&`;
          }
          path += query;
        }
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(path)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
      } else {
        this.$router.push({
          path: '/personalCenter/myCoupon',
        });
      }
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.couppon_card_box {
  .title {
    margin-left: 36px;
    margin-bottom: 22px;
    height: 40px;
    font-size: 29px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 40px;
  }

  ul {
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;

    &::-webkit-scrollbar {
      display: none;
    }

    li {
      display: inline-block;
      margin-right: 18px;

      &:first-child {
        margin-left: 36px;
      }

      &:last-child {
        margin-right: 36px;
      }

      // background: #fff;
      // border-radius: 18px;
    }

    .couppon_card {
      position: relative;
      margin-bottom: 30px;

      .isRecommend {
        position: absolute;
        top: 0;
        right: 0;
        width: 58px;
        height: 33px;
        color: #fff;
        font-size: 22px;
        line-height: 33px;
        text-align: center;
        background: #ff6c02;
        border-radius: 0 5px 0 5px;
      }

      .slot {
        // position: absolute;
        // bottom: 0;
        z-index: 100;
        text-align: center;
        height: 36px;
        margin-top: 12px;
        display: flex;
        justify-content: center;
        align-items: center;

        .btn {
          width: 96px;
          color: #fff;
          font-size: 18px;
          line-height: 36px;
          text-align: center;
          background: rgba(255, 83, 20, 1);
          border-radius: 18px;
        }

        .btn.active {
          color: #fff;
          background: rgba(255, 83, 20, 1);
        }

        img {
          width: 116px;
        }
      }
    }
  }

  .defaultImg {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 290px;
    margin: 0 auto;

    img {
      display: block;
      width: 290px;
      height: 290px;
    }

    p {
      color: #787878;
      font-size: 25px;
      line-height: 36px;
    }
  }
}
</style>
